import common from 'store/modules/common/api'

const prepareQuery = (since, until) => {
 const parts = []
 if (since) { parts.push(`since=${encodeURIComponent(since)}`)}
 if (until) { parts.push(`until=${encodeURIComponent(until)}`)}

 return parts.length > 0 ? `?${parts.join('&')}` : ''
}

export const api = {
  throwError: (timeout) => new Promise((resolve, reject) => setTimeout(() => reject(new Error("Error occurred...")), timeout || 2000)),
  getTopSuppliers: () => common.httpClient.get(`/api/services/app/DataProvider/GetTopSuppliers`, common.options()).then(r => common.processResponse(r)),
  getStorageStatuses: () => common.httpClient.get(`/api/services/app/DataProvider/GetStorageStatuses`, common.options()).then(r => common.processResponse(r)),
  getSoldByChannels: (year) => common.httpClient.get(`/api/services/app/DataProvider/GetSoldByChannels?year=${year}`, common.options()).then(r => common.processResponse(r)),
  getSellsByTime: (since, until) => common.httpClient.get(`/api/services/app/DataProvider/GetSellsByTime${prepareQuery(since, until)}`, common.options()).then(r => common.processResponse(r)),
  getBottlesByStatus: () => common.httpClient.get(`/api/services/app/DataProvider/GetBottlesByStatus`, common.options()).then(r => common.processResponse(r)),
}
